<template>
  <div class="feed_commit">
    <van-nav-bar
      title="历史反馈"
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="success">
      <div class="item-success"></div>
      <p class="message">您的反馈已提交成功</p>
      <p class="sub_message">非常感谢您的使用和建议，我们会及时针对您的问题进行解答，请耐心等待哦～</p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { NavBar } from 'vant'
Vue.use(NavBar);

export default {
  methods: {
    onClickLeft: function () {
      this.$router.push({path: '/feedback/record'})
    },
  }
}
</script>

<style lang="less" scoped>
.feed_commit {
  display: block;
  width: 100%;
  max-width: 3.75rem;
  min-height: 100vh;
  overflow: hidden;

  .success {
    display: block;
    width: 2.79rem;
    margin: 0 auto;
    margin-top: .65rem;
    overflow: hidden;

    .item-success {
      display: block;
      width: .582rem;
      height: .582rem;
      margin: 0 auto;
      background:url("~@/assets/images/feedback/success.png") no-repeat;
      background-size: .58rem;
      overflow: hidden;
    }
    .message {
      display: block;
      margin-top: .22rem;
      font-size: 16px;
      color: #333333;
      text-align: center;
    }
    .sub_message {
      display: block;
      margin-top: .08rem;
      font-size: 14px;
      color: #999999;
    }
  }
  /deep/ .van-empty__image {
    width: .65rem;
    height: .65rem;
  }
  /deep/ .van-nav-bar{
    margin-top: .26rem;
  }
  /deep/.van-icon {
    color: #666666;
  }
  /deep/.van-nav-bar__title {
    font-size: 18px;
    color: #333333;
  }
}
</style>